module.exports = __webpack_public_path__ + "img/3.08.7be96540.jpg";